import PropTypes from "prop-types";

export default PropTypes.PropTypes.shape({
  action: PropTypes.string,
  action_at: PropTypes.string,
  attachment_link: PropTypes.string,
  attachment_name: PropTypes.string,
  author: PropTypes.object,
  created_at: PropTypes.string,
  id: PropTypes.number,
  message: PropTypes.string,
});
